export function locationAssign(url: string): void {
  window.location.assign(url);
}
